export const en = {
  refresh: 'Refresh'
};

export type Translations = typeof en;
